import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Resolution } from 'src/app/shared/models/resolution.model';

@Injectable({
  providedIn: 'root'
})
export class ResolutionAssignListService {

  private url: string;
  private key: string;

  constructor(private http: HttpClient, public router: Router) {
      this.url = environment.apiUrl;
      this.key = environment.apiKey;
  }

  /**
   * 
   * @param filter 
   * @param offset 
   * @param limit 
   */
  public resolveResolutions(stockId: string, purposeId: string, filter: string, offset: number, limit: number): Observable<object>
  {
    if (filter === '') {
      return this.getAllResolutions(stockId, purposeId, offset, limit);
    } else {
      return this.getFilteredResolutions(stockId, purposeId, filter, offset, limit);
    }
  }

  /**
   *
   */
  public getAllResolutions(stockId: string, purposeId: string, offset: number, limit: number): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('stockId'  , stockId)
      .append('purposeId', purposeId)
      .append('offset', offset.toString())
      .append('limit' , limit.toString());

    return this.http
               .get(`${this.url}/resolutions/assign`, {responseType: 'json', headers, params })
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   * 
   * @param filter 
   * @param offset 
   * @param limit 
   */
  private getFilteredResolutions(stockId: string, purposeId: string, filter: string, offset: number, limit: number): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    const params = new HttpParams()
      .append('stockId'  , stockId)
      .append('purposeId', purposeId)
      .append('filter', filter)
      .append('offset', offset.toString())
      .append('limit' , limit.toString());

    return this.http
               .get(`${this.url}/resolutions/assign/search`, { responseType: 'json', headers, params })
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   *
   */
  public getStocks(): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .get(`${this.url}/stocks`, {responseType: 'json', headers})
               .pipe(
                 catchError(this.errorHandler)
               );
  }

  /**
   *
   */
  public getPurposes(): Observable<object> {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .get(`${this.url}/purposes`, {responseType: 'json', headers})
               .pipe(
                 catchError(this.errorHandler)
               );
  }

    /**
   *
   */
     public getFormats(): Observable<object> {
      const headers = new HttpHeaders()
        .append('x-api-key', this.key);
  
      return this.http
                 .get(`${this.url}/images/formats`, {responseType: 'json', headers})
                 .pipe(
                   catchError(this.errorHandler)
                 );
    }

  /**
   *
   * @param purpose
   */
  assign(stockId: number, purposeId: number, resolutionId: number) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

      const params = new HttpParams()
      .append('stockId'  , stockId.toString())
      .append('purposeId', purposeId.toString())
      .append('resolutionId', resolutionId.toString())

    return this.http
               .post(`${this.url}/resolutions/assign`, null, { responseType: 'json', headers, params })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param purpose
   */
  create(resolution: Resolution) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .post(`${this.url}/resolutions`, resolution, { responseType: 'json', headers })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param stock
   */
  update(resolution: Resolution) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .put(`${this.url}/resolutions`, resolution, { responseType: 'json', headers })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param id
   */
  delete(id: number) {
    const headers = new HttpHeaders()
      .append('x-api-key', this.key);

    return this.http
               .delete(`${this.url}/resolutions/${id}`, { responseType: 'json', headers })
               .pipe(
                catchError(this.errorHandler)
              );
  }

  /**
   *
   * @param error
   */
  private errorHandler(error: HttpErrorResponse) {
    console.log('Ha ocurrido un error al ejecutar el endpoint: ', error);
    return throwError(error);
  }
}
